import { createContext } from 'react';

const RecipeDetailsContext = createContext();

export default RecipeDetailsContext;
